import t from"react";import{mdiDotsVertical as o}from"@mdi/js";import{MdIcon as r}from"./MdIcon.js";const e=({id:e="more",title:m="More",...i})=>t.createElement(r,{id:e,title:m,path:o,...i});export{e as MoreIcon};
